/**
 * Returns the string meaning the side where cell is moved
 * dx, dy - difference between old and new coords
 * */
function moveDirection(dx, dy) {
  let sn = '',
    we = '';

  if (dy) {
    sn = dy > 0 ? 'south' : 'north';
  }

  if (dx) {
    we = dx > 0 ? 'east' : 'west';
  }

  const direction = sn + we;

  return direction;
}

/** Returns the string meaning from which side flowline is "growing"
 * X, Y - exit or entry points of flowline (take if from edge style)
 * */
function eDirection(X, Y) {
  let direction;

  if (X !== 0 && X !== 1) {
    direction = Y > 0 ? 'south' : 'north';
  }

  if (Y !== 0 && Y !== 1) {
    direction = X > 0 ? 'east' : 'west';
  }

  return direction;
}

/**Simple movement plane detectors */
function isHorizontal(direction) {
  return direction.indexOf('west') >= 0 || direction.indexOf('east') >= 0;
}

function isVertical(direction) {
  return direction.indexOf('north') >= 0 || direction.indexOf('south') >= 0;
}

/**
 * Check if the reset of edge is needed
 *
 * absX, absY - calculated points of where line is connected to vertex
 * wps - array of waypoints of an edge
 * moveDirection - name of the side where cell is moved
 * eDirection - name of the side from where line is connected to vertex
 * TS - geometry of target/source
 * isSource - true if source of flowline is moved, false if the target was moved
 * */
function needReset(absX, absY, wps, moveDir, eDir, TS, isSource) {
  const buffer = 30;
  let wp;

  const wpOverlap = wps.some(function (item) {
    const xInter = [TS.x, TS.x + TS.width];
    const yInter = [TS.y, TS.y + TS.height];

    return xInter[0] < item.x && item.x < xInter[1] && yInter[0] < item.y && item.y < yInter[1];
  });

  if (wpOverlap) {
    return true;
  } else {
    if (isSource) {
      wp = wps[0];
    } else {
      wp = wps[wps.length - 1];
    }

    // check if cell comes too close to the waypoint
    if (moveDir.indexOf('north') >= 0 && eDir === 'north') {
      if (wp.y > absY - buffer) {
        return true;
      }
    } else if (moveDir.indexOf('south') >= 0 && eDir === 'south') {
      if (wp.y < absY + buffer) {
        return true;
      }
    } else if (moveDir.indexOf('west') >= 0 && eDir === 'west') {
      if (wp.x > absX - buffer) {
        return true;
      }
    } else if (moveDir.indexOf('east') >= 0 && eDir === 'east') {
      if (wp.x < absX + buffer) {
        return true;
      }
    } else {
      return false;
    }
  }
}

function translateWaypoints(wps, dx, dy) {
  const waypoints = [];

  if (wps) {
    wps.forEach(wp => {
      const cloned = wp.clone();

      cloned.x = cloned.x += dx;
      cloned.y = cloned.y += dy;
      waypoints.push(cloned);
    });

    return waypoints;
  }
}

function getPointsBySide(side) {
  switch (side) {
    case 'north':
      return [0.5, 0];

    case 'west':
      return [0, 0.5];

    case 'east':
      return [1, 0.5];

    case 'south':
      return [0.5, 1];
  }
}

export {
  moveDirection,
  eDirection,
  isHorizontal,
  isVertical,
  needReset,
  translateWaypoints,
  getPointsBySide
};
